import { useOne } from '@refinedev/core';
import { Client } from 'src/admin/users/types';

export const useClient = (clientId: string | undefined) => {
  const { data, isLoading, error } = useOne<Client>({
    resource: 'clients',
    id: clientId!,
    queryOptions: { enabled: !!clientId },
  });

  return {
    client: data?.data || null,
    isLoading,
    error,
  };
};
